import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { AppInsightsLogginService } from './logging.service';

@Injectable()
export class ErrorHandlerService extends ErrorHandler {
    constructor(private injector: Injector) {
        super();
    }
    override handleError(error: Error) {
        if (error?.name === 'ChunkLoadError') {
            window.location.reload();
            return;
        }
        const authErrors = ['Login required', 'consent_required', 'interaction_required', 'missing_refresh_token'];
        if (authErrors.includes(error?.message)) {
            console.warn('Auth0 warning:', error.message);
            return;
        }
        console.error(error);
        const appInsightsLoggingService= this.injector.get(AppInsightsLogginService);
        appInsightsLoggingService.logException(error);
    }
}